import {
  type CursorData,
  type CursorOverlayState,
  useCursorOverlay,
} from "@platejs/selection/react";
import editorStyles from "./styles/SlateEditor.module.scss";

export function Cursor({ selectionRects }: CursorOverlayState<CursorData>) {
  return (
    <>
      {selectionRects.map((position, i) => {
        return (
          <div
            key={i}
            className={editorStyles.cursorOverlay}
            style={{
              ...position,
              position: "absolute",
            }}
          />
        );
      })}
    </>
  );
}

export function CursorOverlay() {
  const { cursors } = useCursorOverlay();

  return (
    <>
      {cursors.map((cursor) => (
        <Cursor key={cursor.id} {...cursor} />
      ))}
    </>
  );
}
